export const PrintFooter = () => (
  <div className="print-footer" data-testid="print-footer">
    <span>Document confidentiel — SCIC SAS OBJECTIF SCOP OUTREMER — Diffusion interne uniquement</span>
  </div>
);
